const Resources = {

    table_headers: [
        {
            name: 'Description',
        },
        {
            name: 'Sq. Feet',
        },
        {
            name: 'Task',
        },
        {
            name: 'Prod. standard',
        },
        {
            name: 'Frequency',
        },
        {
            name: 'Minutes',
        },
        {
            name: 'Annual min',
        },
        {
            name: 'Task',
            style: 'background-color: rgb(209 234 251);'
        },
        {
            name: 'Prod. standard',
            style: 'background-color: rgb(209 234 251);'
        },
        {
            name: 'Frequency',
            style: 'background-color: rgb(209 234 251);'
        },
        {
            name: 'Minutes',
            style: 'background-color: rgb(209 234 251);'
        },
        {
            name: 'Annual min',
            style: 'background-color: rgb(209 234 251);'
        },
        {
            name: 'Daily difference',
            style: 'background-color: rgb(209 234 251);'
        },
        {
            name: 'Annual difference',
            style: 'background-color: rgb(209 234 251);'
        },
    ],

    headers_report_table: [
        {
          title: 'Description',
          dataKey: 'custom_description',
          cellWidth: '40'
        },
        {
          title: 'SQ FT',
          dataKey: 'sq_ft'
        },
        {
          title: 'Task',
          dataKey: 'task'
        },
        {
            title: 'PROD STD',
            dataKey: 'production_standard'
        },
        {
            title: 'FREQ',
            dataKey: 'frequency'
        },
        {
            title: 'MIN',
            dataKey: 'room_task_minutes'
          },
          {
            title: 'ANN MIN',
            dataKey: 'annual_minutes'
          },
          {
            title: 'Task',
            dataKey: 'fake_task_name'
          },
          {
              title: 'PROD STD',
              dataKey: 'fake_production_standard'
          },
          {
            title: 'FREQ',
            dataKey: 'fake_frequency'
          },
          {
            title: 'MIN',
            dataKey: 'format_fake_daily_minutes'
          },
          {
            title: 'ANN MIN',
            dataKey: 'fake_annual_minutes'
          },
          {
            title: 'DLY DIF',
            dataKey: 'daily_diference'
          },
          {
              title: 'ANN DIF',
              dataKey: 'annual_diference'
          },
    ],

    breadcrumb: [
        {
            name: 'Home',
            href: '/',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'Budgeting',
            href: '#',
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: 'Forecaster',
            href: '#',
            arrow: "",
        },
    ],

    radio_options: [
        {
            div_class: 'col-md-3 p-0 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'unit',
            name: 'Daily',
            model: 'unit',
        },
        {
            div_class: 'col-md-3 p-0 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'project',
            name: 'Project',
            model: 'project',
        },
        {
            div_class: 'col-md-3 p-0 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'policing',
            name: 'Policing',
            model: 'policing',
        },
        {
            div_class: 'col-md-3 p-0 form-check custom-radio',
            input_class: 'custom-control-input',
            ref: 'all',
            name: 'All',
            model: 'all',
        },
    ],

    helps: [
        {
            label: '¿How to use the Forecaster?', 
            instruction: `https://scribehow.com/embed/How_to_Use_the_Forecaster__574J3XnwQvaxPdzsWo3pew?as=scrollable`
        },
    ],
}

export default Resources;